import type { ButtonHTMLAttributes } from 'react';

/** BotCore.html.box: SVG стоит всегда; исходный CSS проявляет крестик у выбранного чипа. */
export function PromptChip({
  label,
  selected,
  className = '',
  variant = 'scene',
  ...props
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & { label: string; selected: boolean; variant?: 'scene' | 'action' }) {
  const cross = (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  );
  return (
    <button {...props} type="button" className={`chip${selected ? ' on' : ''}${className ? ` ${className}` : ''}`} aria-pressed={selected}>
      {label}
      {variant === 'action' ? (
        <span className="xx" aria-hidden="true">
          {cross}
        </span>
      ) : (
        cross
      )}
    </button>
  );
}
